import { render } from "./PopUpWrapperWithoutBackground.vue?vue&type=template&id=11e2d81d"
import script from "./PopUpWrapperWithoutBackground.vue?vue&type=script&lang=js"
export * from "./PopUpWrapperWithoutBackground.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__